import { addTransportConditionCheckedItem, resetTransportFilterCheckedItems, setTransportConditionSelectedDatetime, setTransportSearchValue, setTransportSelectedItem } from 'app/actions/map';
import * as actions from 'app/actions/notification';
import { NOTIFICATION_DELETE_ALL_QUEUE } from 'app/utils/constants';
import { formatNonemptyOilParkingAlertText, NONEMPTY_OIL_PARKING_ALERT_HEADER_COLOR, NONEMPTY_OIL_PARKING_ALERT_TITLE } from 'app/utils/nonemptyOilParkingAlert';
import { batch } from 'react-redux';
// ПО промежуточного слоя использует действия для взаимодействия
// с уведомлениями и остальными сообщениями приложения.
export const notificationMiddleware = function () {
    const queue = [];
    // Создание уникального идентификатора для очереди уведомлений.
    const createQueueId = (length) => {
        const chars = [...'0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'];
        return [...Array(length)].map(() => chars[(Math.random() * chars.length) | 0]).join('');
    };
    // Обработчик события добавления уведомления.
    const addEvent = (dispatch, payload) => {
        const { text, color, timeout = config.snackbarTimeout, action = null, actionLabel = null, isTransportEvent = false, isOilParkingAlert = false, event_id = null, title = null, headerColor = null } = payload;
        // Создадим уникальный ключ для управления уведомлением.
        const id = createQueueId(16);
        // Запустить таймер на удаление уведомления из очереди.
        const clearQueue = () => {
            const timeoutId = window.setTimeout(() => {
                dispatch(actions.deleteItem(id));
                // Проверим очередь уведомлений.
                checkQueue(dispatch);
            }, timeout);
            return timeoutId;
        };
        const timeoutId = timeout > 0 ? clearQueue() : timeout;
        // Отправка действий для создания уведомления в Redux.
        dispatch(actions.addItem({
            id,
            timeoutId,
            text,
            color,
            action,
            actionLabel,
            isTransportEvent,
            isOilParkingAlert,
            event_id,
            title,
            headerColor,
        }));
    };
    // Обработчик события удаление уведомления.
    const deleteEvent = (dispatch, value) => {
        // Удалить таймер на удаление уведомления.
        if (value.timeout > 0) {
            clearTimeout(value.timeout);
        }
        // Отправка действия на удаление уведомления из Redux.
        dispatch(actions.deleteItem(value.id));
        // Проверим очередь уведомлений.
        checkQueue(dispatch);
    };
    // Обработчик события удаление всех уведомлений.
    const deleteAllEvents = (dispatch, values) => {
        // Очистить отложенную очередь: иначе после «Закрыть все»
        // накопленные за время отсутствия оповещения снова появятся по одному через checkQueue.
        queue.length = 0;
        // Отправка действия на удаление уведомления из Redux.
        dispatch(actions.deleteAllItems());
        for (let value of values) {
            // Удалить таймер на удаление уведомления.
            if (value.timeoutId > 0) {
                clearTimeout(value.timeoutId);
            }
        }
    };
    // Обработчик события проверки очереди уведомлений.
    const checkQueue = (dispatch) => {
        if (queue.length) {
            // Отправим действие на добавление уведомления.
            addEvent(dispatch, queue[queue.length - 1]);
            // Удалим уведомление из очереди.
            queue.splice(queue.length - 1, 1);
        }
    };
    return (store) => (next) => (action) => {
        switch (action.type) {
            case 'NOTIFICATION_ADD_QUEUE': {
                const { items } = store.getState().notification;
                // Если количество уведомлений на экране больше заданного лимита.
                if (items.length >= config.snackbarLimit) {
                    queue.unshift(action.payload);
                    break;
                }
                addEvent(store.dispatch, action.payload);
                break;
            }
            case 'NOTIFICATION_ADD_EVENT_QUEUE': {
                const { permissions } = store.getState().session.session;
                // Заменить данное условие при влитии 411 задачи, где изменено разграничение прав по ролям.
                if (!permissions.includes('drain')) {
                    return;
                }
                const { datetime, geofence_id, geofence_name, transport_id, event_id } = action.payload;
                const { ref: mapRef, transportItems } = store.getState().map;
                const { id, number } = transportItems.find((item) => item.id === transport_id) || {};
                if (id) {
                    // Определяем фильтр и сообщение в зависимости от event_id
                    const eventFilter = event_id === 12 ? 'event_id:12' : 'event_id:1';
                    const eventMessage = config.mapTransportEventMessages[event_id.toString()] || config.mapTransportEventMessages['1'];
                    store.dispatch({
                        type: 'NOTIFICATION_ADD_QUEUE',
                        payload: {
                            text: eventMessage
                                .replace('$datetime', moment.utc(datetime).local().format('DD.MM.YYYY HH:mm:ss'))
                                .replace('$name', number)
                                .replace('$geofence', geofence_id ? geofence_name : '')
                                .replace('в геозоне «»', ''),
                            action: () => {
                                var _a, _b, _c, _d, _e, _f, _g, _h;
                                const transportItem = store.getState().map.transportItems.find((item) => item.id === transport_id);
                                const checkedType = store.getState().map.transportConditionFilterCheckedType;
                                batch(() => {
                                    // Сбрасываем фильтры и поиск
                                    if (checkedType === 'filter') {
                                        store.dispatch(addTransportConditionCheckedItem([eventFilter]));
                                    }
                                    store.dispatch(setTransportSearchValue(''));
                                    store.dispatch(resetTransportFilterCheckedItems());
                                    // Устанавливаем выбранный транспорт
                                    store.dispatch(setTransportSelectedItem(transportItem));
                                    // Устанавливаем конкретное время события
                                    store.dispatch(setTransportConditionSelectedDatetime(moment.utc(datetime).local().format('YYYY-MM-DD HH:mm:ss')));
                                });
                                const lastCondition = (_a = transportItem === null || transportItem === void 0 ? void 0 : transportItem.conditions) === null || _a === void 0 ? void 0 : _a[transportItem.conditions.length - 1];
                                if (((_b = lastCondition === null || lastCondition === void 0 ? void 0 : lastCondition.data) === null || _b === void 0 ? void 0 : _b.geodata) !== 'ERR' && ((_c = lastCondition === null || lastCondition === void 0 ? void 0 : lastCondition.data) === null || _c === void 0 ? void 0 : _c.lat) != null && ((_d = lastCondition === null || lastCondition === void 0 ? void 0 : lastCondition.data) === null || _d === void 0 ? void 0 : _d.lon) != null) {
                                    (_f = (_e = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _e === void 0 ? void 0 : _e.handleClosePopup) === null || _f === void 0 ? void 0 : _f.call(_e);
                                    (_h = (_g = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _g === void 0 ? void 0 : _g.handleFlyTo) === null || _h === void 0 ? void 0 : _h.call(_g, [lastCondition.data.lat, lastCondition.data.lon], null);
                                }
                                deleteEvent(store.dispatch, action.payload);
                            },
                            color: 'warning',
                            timeout: 0,
                            isTransportEvent: true,
                            event_id: event_id,
                        },
                    });
                }
                break;
            }
            case 'NOTIFICATION_ADD_PARKING_ALERT': {
                const { show_oil_parking_notification } = store.getState().session.session;
                if (!show_oil_parking_notification) {
                    return;
                }
                const { datetime, transport_id } = action.payload;
                const { ref: mapRef, transportItems } = store.getState().map;
                const transport = transportItems.find((item) => String(item.id) === String(transport_id));
                if (!transport) {
                    break;
                }
                store.dispatch({
                    type: 'NOTIFICATION_ADD_QUEUE',
                    payload: {
                        title: NONEMPTY_OIL_PARKING_ALERT_TITLE,
                        text: formatNonemptyOilParkingAlertText({
                            number: transport.number || transport.name,
                            datetimeLabel: moment.utc(datetime).local().format('DD.MM.YYYY HH:mm:ss'),
                        }),
                        action: () => {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            const transportItem = store.getState().map.transportItems.find((item) => String(item.id) === String(transport_id));
                            batch(() => {
                                store.dispatch(setTransportSearchValue(''));
                                store.dispatch(resetTransportFilterCheckedItems());
                                store.dispatch(setTransportSelectedItem(transportItem));
                                store.dispatch(setTransportConditionSelectedDatetime(moment.utc(datetime).local().format('YYYY-MM-DD HH:mm:ss')));
                            });
                            const lastCondition = (_a = transportItem === null || transportItem === void 0 ? void 0 : transportItem.conditions) === null || _a === void 0 ? void 0 : _a[transportItem.conditions.length - 1];
                            if (((_b = lastCondition === null || lastCondition === void 0 ? void 0 : lastCondition.data) === null || _b === void 0 ? void 0 : _b.geodata) !== 'ERR' && ((_c = lastCondition === null || lastCondition === void 0 ? void 0 : lastCondition.data) === null || _c === void 0 ? void 0 : _c.lat) != null && ((_d = lastCondition === null || lastCondition === void 0 ? void 0 : lastCondition.data) === null || _d === void 0 ? void 0 : _d.lon) != null) {
                                (_f = (_e = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _e === void 0 ? void 0 : _e.handleClosePopup) === null || _f === void 0 ? void 0 : _f.call(_e);
                                (_h = (_g = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _g === void 0 ? void 0 : _g.handleFlyTo) === null || _h === void 0 ? void 0 : _h.call(_g, [lastCondition.data.lat, lastCondition.data.lon], null);
                            }
                            deleteEvent(store.dispatch, action.payload);
                        },
                        color: 'warning',
                        headerColor: NONEMPTY_OIL_PARKING_ALERT_HEADER_COLOR,
                        timeout: 0,
                        isTransportEvent: true,
                        isOilParkingAlert: true,
                    },
                });
                break;
            }
            case 'NOTIFICATION_DELETE_QUEUE': {
                deleteEvent(store.dispatch, action.payload);
                break;
            }
            case NOTIFICATION_DELETE_ALL_QUEUE: {
                deleteAllEvents(store.dispatch, action.payload);
                break;
            }
            default:
                return next(action);
        }
    };
};
export default notificationMiddleware;
